<template>
	<div class="search-user-machine-alarm">
		<div class="el-search vue-top-padding radius">
			<div class="el-right">
				<el-form
					ref="userMachineAlarm"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height">
					<el-form-item prop="dateTime" style="margin: 0 10px 0 0">
					<el-date-picker
						v-model="dateTime"
						type="datetimerange"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						range-separator="-"
						:picker-options="pickerOptions"
						:default-time="['00:00:00', '23:59:59']"
						:start-placeholder="$t('searchOrder.start')"
						:end-placeholder="$t('searchOrder.end')"
						@change="onSubmit">
					</el-date-picker>
					</el-form-item>
					<el-form-item prop="userName" style="margin: 0 10px 0 0">
						<el-input
							v-model="search.userName"
							:placeholder="$t('searchUserMachineAlarm.userName')" @input="onSubmit"></el-input>
					</el-form-item>
					<el-form-item prop="equipmentNo" style="margin: 0 10px 0 0">
						<el-input
							v-model="search.equipmentNo"
							:placeholder="
								$t('searchUserMachineAlarm.equipmentNo')"
								@input="onSubmit"
								></el-input>
					</el-form-item>
					<el-form-item prop="type" style="margin: 0 10px 0 0">
						<el-select
							v-model="search.type"
							filterable
							:no-data-text="$t('common.noData')"
							:no-match-text="$t('common.noData')"
							:placeholder="$t('searchUserMachineAlarm.alarmType')">
							<el-option
								v-for="item in alarmTypeList"
								:key="item.id"
								:label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="code" style="margin: 0 10px 0 0">
						<el-input
							v-model="search.code"
							:placeholder="$t('searchUserMachineAlarm.alarmCode')"
							@input="onSubmit"></el-input>
					</el-form-item>
					<el-form-item style="margin: 0">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('userMachineAlarm')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
			<el-dialog
				:modal-append-to-body="true"
				:append-to-body="true"
				:title="this.$t('searchUserMachineAlarm.noticefs')"
				:visible.sync="dialogTableVisible"
				:close-on-click-modal="false"
				custom-class="alarmClass">
				<div style="width: 100%; text-align: center">
					<el-checkbox-group
						v-model="checkedWway"
						@change="handleCheckedNoticeWayChange"
						style="display: flex">
						<el-checkbox
							v-for="(way, index) in ways"
							:label="way.id"
							:key="index"
							>{{ way.name }}</el-checkbox
						>
					</el-checkbox-group>
					<el-button
						type="primary"
						@click="handleSubmit"
						size="small"
						style="width: 100%; margin-top: 0.2rem"
						>{{ $t("common.definite") }}</el-button
					>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchUserMachineAlarm",
	props: {
		search: Object,
		dateTime: Array,
		alarmTypeList: Array,
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
						const end = new Date();
						end.setHours(23, 59, 59, 999);
						const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
			dialogTableVisible: false,
			checkedWway: [1],
			ways: [
				{
					id: 2,
					name: this.$t("searchUserMachineAlarm.smsnotice"),
				},
				{
					id: 1,
					name: this.$t("searchUserMachineAlarm.emnotice"),
				},
			],
		};
	},
	methods: {
		getTime(nS) {
			//  获取一个时间对象
			var date = new Date(nS);
			//  获取完整的年份(4位,1970)
			let y = date.getFullYear();
			//  获取月份(0-11,0代表1月,用的时候记得加上1)
			let m =
				date.getMonth() + 1 < 10
					? "0" + (date.getMonth() + 1)
					: date.getMonth() + 1;
			//  获取日(1-31)
			let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			//  获取时(1-24)
			let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			//  获取分(1-60)
			let f =
				date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
			//  获取分(1-60)
			let s =
				date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
			return y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
		},
		onSubmit() {
			console.log(this.dateTime, 11);
			if (
				this.dateTime &&
				this.dateTime.length > 0
			) {
				// Handle both Date objects (from shortcuts) and strings (from value-format)
				if (this.isGarbageTime(this.dateTime[0])) {
					this.search.startTime = this.getTime(this.dateTime[0]);
					this.search.endTime = this.getTime(this.dateTime[1]);
				} else if (typeof this.dateTime[0] === 'string') {
					this.search.startTime = this.dateTime[0];
					this.search.endTime = this.dateTime[1];
				} else {
					this.search.startTime = "";
					this.search.endTime = "";
				}
			} else {
				this.search.startTime = "";
				this.search.endTime = "";
			}
			this.$emit("onSubmit", this.search);
		},
		// 判断是不是垃圾时间
		isGarbageTime(date) {
			return date instanceof Date && !isNaN(date.getTime());
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
		handleNoticeWay() {
			let _self = this;
			let url = _self.$url.AlarmRecord.noticeTypeList;
			let method = _self.$method.get;
			_self.$api
				.request(url, method, {})
				.then(res => {
					if (res.code === 0) {
						let checkedWway = [];
						for (let i = 0; i < res.data.length; i++) {
							checkedWway.push(parseInt(res.data[i]["type"]));
						}
						_self.checkedWway = checkedWway;
						_self.dialogTableVisible = true;
					}
				})
				.catch(() => {});
		},
		handleSubmit() {
			let _self = this;
			let postdata = [];
			for (let i = 0; i < this.checkedWway.length; i++) {
				let poststr = {
					type: _self.checkedWway[i],
				};
				postdata.push(poststr);
			}
			if (postdata.length < 1) {
				this.$notify({
					title: this.$t("common.warning"),
					message: this.$t("searchUserMachineAlarm.zhyz"),
					type: "warning",
				});
				return false;
			}
			let url = _self.$url.AlarmRecord.noticeType;
			let method = _self.$method.post;
			_self.$api
				.request(url, method, postdata)
				.then(res => {
					if (res.code === 0) {
						_self.dialogTableVisible = false;
					}
				})
				.catch(() => {});
		},
	},
};
</script>
<style>
.alarmClass {
	width: 325px;
	height: 150px;
}
</style>
